module.exports = __webpack_public_path__ + "static/img/prices.004caa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/prices.jpg
// module id = ZrIU
// module chunks = 0